import {
  CCol,
  CRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CWidgetStatsC,
} from '@coreui/react-pro'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import React, { useEffect, useState } from 'react'
import Trade from './Trade'
import GameStrucurePage from './GameStrucurePage'
import SalaryCapPage from './SalaryCapPage'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'
import PlayerStructure from '../Player/PlayerStructure/PlayerStructure'
import GamePrivacy from './GamePrivacy'
import CIcon from '@coreui/icons-react'
import {
  cilDollar,
  cilGroup,
  cilLockUnlocked,
  cilStar,
  cilStarHalf,
  cilTransfer,
} from '@coreui/icons'
import Loader from 'src/components/Loader'
import TeamSelectionLimit from '../Player/PlayerStructure/TeamSelectionLimit'
import PlayerAlert from './PlayerAlert'

const GameStructure = () => {
  const [gameSpotData, setGameSpotData] = useState({})
  const [savedSalaryCap, setSavedSalaryCap] = useState('')
  const [isTeamExists, setIsTeamExists] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [rangeValue, setRangValue] = useState(100)

  const [defaultTrade, setDefaultTrade] = useState(20)
  const [gameStuctureData, setGameStructureData] = useState()
  const [gameData, setGameData] = useState()
  const [playerStructuredetails, setPlayerStructureDetails] = useState({})
  const [gameprivacy, setGamePrivacy] = useState({})
  const [showTeamSelectionStatus, setShowTeamSelectionStatus] = useState(0)
  const handleTeamSelectionLimitChangeStatus = (event) => {
    const value = event.target.id === 'default-sidebar-color' ? 0 : 1
    setShowTeamSelectionStatus(value)
  }
  useEffect(() => {
    CommonService.gameStructureInfo()
      .then((res) => {
        if (res.status === 200) {
          setGameData(res.game_data)
          setGameSpotData(res.game_spot)
          setGameStructureData(res.game_structure)
          setPlayerStructureDetails(res.multiplayer_data)
          setRangValue(res.game_data?.salary_cap)
          setDefaultTrade(res.game_data?.trades)
          setSavedSalaryCap(res.multiplayer_data.salary)
          setGamePrivacy(res.game_privacy)
          setIsTeamExists(res.is_team_exists)
          setShowTeamSelectionStatus(res.game_data?.team_selection_limit_status)
          setIsLoading(false)
        }
      })
      .catch((e) => {
        console.log('E=> ', e)
        ToastComponent('Something went wrong. Please try again', 'error')
      })
  }, [])
  var boxTeamSize = { 8: '6', 7: '7', 6: '8', 5: '9', 1: '10', 1002: '11' }
  return (
    <>
      <CRow>
        <CCol sm={6} md={2}>
          <CWidgetStatsC
            color="info-gradient"
            icon={<CIcon icon={cilGroup} height={36} />}
            value={gameData?.team_size}
            title="Team Size"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={2}>
          <CWidgetStatsC
            color="success"
            icon={<CIcon icon={cilDollar} height={36} />}
            value={`$${gameData?.salary_cap}m`}
            title="Salary Cap"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={2}>
          <CWidgetStatsC
            color="warning-gradient"
            icon={<CIcon icon={cilTransfer} height={36} />}
            value={defaultTrade}
            title="Trades"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={2}>
          <CWidgetStatsC
            color="primary-gradient"
            icon={<CIcon icon={cilLockUnlocked} height={36} />}
            value={gameprivacy?.game_visibility === 2 ? 'Private' : 'Public'}
            title="Visibility"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={2}>
          <CWidgetStatsC
            color="danger-gradient"
            icon={<CIcon icon={cilStar} height={36} />}
            value="2x"
            title="Captain"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={2}>
          <CWidgetStatsC
            color="info-gradient"
            icon={<CIcon icon={cilStarHalf} height={36} />}
            value="1.5x"
            title="Vice-Captain"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
      </CRow>
      <CRow>
        <CAccordion activeItemKey={1} alwaysOpen>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              {' '}
              <strong>Team Size</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <GameStrucurePage
                gameStuctureData={gameStuctureData}
                setGameStructureData={setGameStructureData}
                setPlayerStructureDetails={setPlayerStructureDetails}
                isTeamExists={isTeamExists}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
        <CAccordion activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              <strong>Player Selection Mode</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <PlayerStructure
                playerStructuredetails={playerStructuredetails}
                setPlayerStructureDetails={setPlayerStructureDetails}
                isTeamExists={isTeamExists}
                gameData={gameData}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
        <CAccordion activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              <strong>Salary Cap ($m) </strong>
            </CAccordionHeader>
            <CAccordionBody>
              {' '}
              <SalaryCapPage
                rangeValue={rangeValue}
                setRangValue={setRangValue}
                savedSalaryCap={gameData?.salary_cap}
                isTeamExists={isTeamExists}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
        <CAccordion activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              <strong>Trades</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <Trade
                defaultTrade={defaultTrade}
                setDefaultTrade={setDefaultTrade}
                gameData={gameData}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
        <CAccordion activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              <strong>Game Privacy </strong>
            </CAccordionHeader>
            <CAccordionBody>
              <GamePrivacy
                gameprivacy={gameprivacy}
                setGamePrivacy={setGamePrivacy}
                gameData={gameData}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
        <CAccordion activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              <strong>Squad Alert </strong>
            </CAccordionHeader>
            <CAccordionBody>
              <PlayerAlert gameData={gameData} />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
        {gameData?.game_type !== 1 && (
          <CAccordion activeItemKey={1}>
            <CAccordionItem itemKey={1}>
              <CAccordionHeader>
                <strong>Player Selection Limit </strong>
              </CAccordionHeader>
              <CAccordionBody>
                {isLoading ? (
                  <Loader />
                ) : (
                  <TeamSelectionLimit
                    gameData={gameData}
                    handleTeamSelectionLimitChangeStatus={handleTeamSelectionLimitChangeStatus}
                    showTeamSelectionStatus={showTeamSelectionStatus}
                    setShowTeamSelectionStatus={setShowTeamSelectionStatus}
                  />
                )}
              </CAccordionBody>
            </CAccordionItem>
          </CAccordion>
        )}

        <CCol xs={12} className="mb-4"></CCol>
        {/* <CCol xs={12} className="mb-4">
        <CViceCaptain />
      </CCol> */}
      </CRow>
    </>
  )
}

export default GameStructure
